export default {"src":"/_next/static/image/public/images/ic_in_person_consult_green.66183baa2f1fac7fd03e29a542f487a1.svg","height":15,"width":16};